import { render, staticRenderFns } from "./forgotPasswordPage.vue?vue&type=template&id=9915981a&scoped=true&"
import script from "./forgotPasswordPage.vue?vue&type=script&lang=js&"
export * from "./forgotPasswordPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9915981a",
  null
  
)

export default component.exports